import React, { memo } from "react";
import styles from "./CommonDialog.module.scss";

type Props = {
	children: React.ReactNode;
	zIndex?: number;
	onCloseDialog?: () => void;
	noPadding?: boolean;
	borderRadius?: string;
	/** On mobile (<= md), dock to the bottom as a full-width bottom sheet instead of a centered dialog. */
	bottomSheetOnMobile?: boolean;
};

const CommonDialog: React.FC<Props> = memo((props: Props) => {
	const { onCloseDialog, children, zIndex, noPadding, borderRadius, bottomSheetOnMobile } = props;

	function handleChildClick(event: React.MouseEvent<HTMLDivElement>) {
		event.stopPropagation();
	}

	return (
		<div className={`${styles.container} ${bottomSheetOnMobile ? styles.bottomSheet : ""}`} onClick={onCloseDialog} style={zIndex ? { zIndex: zIndex } : {}}>
			<div className={`${styles.dialogContainer} ${noPadding ? styles.noPadding : ""}`} onClick={handleChildClick} style={{ ...(zIndex ? { zIndex: zIndex + 1 } : {}), ...(borderRadius ? { borderRadius } : {}) }}>
				{children}
			</div>
		</div>
	);
});

export default CommonDialog;
